// Layout-math constants only: importers (skeleton layout, pane layout hook)
// must not pull the pane component itself into the shared bundle.
export const DEFAULT_WORKSPACE_PANE_WIDTH = 480;
export const MIN_WORKSPACE_PANE_WIDTH = 360;

/**
 * Chat floor while the pane is open — below MIN_CHAT_PANE_WIDTH (640) on
 * purpose: the chat squeezes so the summary panel can shrink beside the pane
 * instead of being replaced on typical laptop widths.
 */
export const SQUEEZED_CHAT_PANE_WIDTH = 400;
